import { EMPTY_TRAINING_PROFILE, parseTrainingProfile } from '../constants/trainingProfileOptions';
import { ensureTrainingProfileDefaults } from '../constants/trainingProfileDefaults';
import { readGoalTiersFromUser, syncGoalSlugsFromTiers } from './trainingGoalTiers';
import { parseWorkoutsPerWeek } from '../constants/workoutWizardSteps';

export function computeAgeYears(birthDateStr) {
  if (!birthDateStr) return null;
  const d = new Date(birthDateStr);
  if (Number.isNaN(d.getTime())) return null;
  const diff = Date.now() - d.getTime();
  return Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000));
}

export function computeBmiDisplay(heightCm, weightKg) {
  const h = parseFloat(heightCm);
  const w = parseFloat(weightKg);
  if (!h || !w || h <= 0) return null;
  const m = h / 100;
  const bmi = w / (m * m);
  if (!Number.isFinite(bmi)) return null;
  return bmi.toFixed(1);
}

export function workoutsPerWeekFromUser(user) {
  const days = user?.trainingProfile?.schedulePattern?.daysPerWeek;
  const parsed = parseWorkoutsPerWeek(days);
  return parsed != null ? String(parsed) : '3';
}

export function buildWizardFormFromUser(user) {
  const tiers = readGoalTiersFromUser(user);
  const slugs = syncGoalSlugsFromTiers(tiers);
  const bd = user?.birthDate != null ? String(user.birthDate).slice(0, 10) : '';
  const wpw = workoutsPerWeekFromUser(user);
  const trainingProfile = ensureTrainingProfileDefaults(parseTrainingProfile(user?.trainingProfile));
  const count = parseWorkoutsPerWeek(wpw) || 3;

  return {
    name: user?.name || '',
    level: user?.level || 'intermediario',
    trainingGoalSlugs: slugs,
    trainingGoalTiers: tiers,
    physicalState: user?.physicalState || '',
    trainingInterests: user?.trainingInterests || '',
    previousTrainingBase: user?.previousTrainingBase || '',
    heightCm: user?.heightCm != null ? String(user.heightCm) : '',
    weightKg: user?.weightKg != null ? String(user.weightKg) : '',
    birthDate: bd,
    workoutsPerWeek: wpw,
    trainingProfile: {
      ...trainingProfile,
      schedulePattern: {
        ...trainingProfile.schedulePattern,
        daysPerWeek: count,
      },
    },
  };
}

export function syncWorkoutsPerWeekToForm(formData, workoutsPerWeek) {
  const count = parseWorkoutsPerWeek(workoutsPerWeek) || 3;
  const trainingProfile = ensureTrainingProfileDefaults(formData.trainingProfile || { ...EMPTY_TRAINING_PROFILE });
  return {
    ...formData,
    workoutsPerWeek: String(count),
    trainingProfile: {
      ...trainingProfile,
      schedulePattern: {
        ...trainingProfile.schedulePattern,
        daysPerWeek: count,
      },
    },
  };
}
